<template>
  <header class="header">
    <a :href="envDomain" class="header__logo">
      <img src="/static/img/ulmar/logo.svg" alt="ユルマール">
    </a>
  </header>
</template>

<script>
import getUlmarEnvDomain from '@/utils/getUlmarEnvDomain'

export default {
  name: 'HeaderUlmar',
  data() {
    return {
      envDomain: getUlmarEnvDomain(),
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../sass/commons/commonVariables.scss';

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  width: 100%;
  background: #fff;
  &__logo {
    img {
      vertical-align: middle;
    }
  }
  // @include mq('pc') {
  //   height: 80px;
  //   padding: 0 30px;
  //   justify-content: flex-start;
  //   &__logo {
  //     img {
  //     }
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Ulmar/partials/HeaderUlmar.vue